export default theme => ({
  page_footer_copyright: {
    fontSize: 12,
    height: 40,
    color: theme.palette.white.main,
  },
});
